import { ContentState, convertFromRaw, RawDraftContentState } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import React, { Fragment } from 'react';
type Props = {
  rawDraftContentState: RawDraftContentState;
};

export const DraftJsonText = ({ rawDraftContentState }: Props) => {
  const contentState = convertFromRaw(rawDraftContentState);

  const content = contentStateToHtml(contentState);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
};

export const contentStateToHtml = (contentState: ContentState) => {
  return convertToHTML({
    entityToHTML: (entity, originalText) => {
      if (entity.type == 'LINK') {
        return (
          <a href={entity.data.url} target="_blank" rel="noreferrer">
            {originalText}
          </a>
        );
      } else if (entity.type == 'image') {
        return (
          <figure>
            <img src={entity.data.src} />
          </figure>
        );
      } else if (entity.type == 'mention') {
        return <span className={'mention'}>{`@${entity.data.mention.name}`}</span>;
      }

      return originalText;
    },
    blockToHTML: (block) => {
      if (block.type == 'unstyled') {
        const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
        const matches = block.text.match(regexpUrl);

        if (matches) {
          const urls = matches.map((m) => m).join('|');
          const reg = new RegExp(`(${urls})`);
          const texts = block.text.split(reg);

          return (
            <>
              {texts.map((t) => (
                <Fragment key={`${crypto.randomUUID()}`}>
                  {urls.includes(t) ? (
                    <a href={t} target="_blank" rel="noreferrer">
                      {t}
                    </a>
                  ) : (
                    <>{t}</>
                  )}
                </Fragment>
              ))}
            </>
          );
        }
      }
      return <p />;
    },
  })(contentState);
};
